module.exports = __webpack_public_path__ + "img/32.d3b6b529.svg";